export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8907.3dd1e391.jpg";